"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _auth = require("../../../reducers/auth");

var _auth2 = _interopRequireDefault(_auth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var authReducer = _auth2.default;
exports.default = authReducer;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/reducers/auth/index.ts
 ** module id = 1290
 ** module chunks = 0
 **/